import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Use
import { useDesktop, useTablet } from 'use/media'

// Components
import BaseButton from 'react-bootstrap/Button'

// Styles
import './Button.scss'

export const Button = ({
  className,
  loading,
  underline,
  iconLeft,
  iconRight,
  width,
  widthTablet,
  widthDesktop,
  children,
  ...props
}) => {
  const isTablet = useTablet()
  const isDesktop = useDesktop()

  // Class list
  const classList = useMemo(() => {
    const classes = [className, 'x-button']

    if (loading) {
      classes.push('btn--loading')
    }

    if (underline) {
      classes.push('btn--underline')
    }

    return classes.join(' ')
  }, [className, loading, underline])

  // Styles
  const style = useMemo(() => {
    const styles = {}

    if (width) {
      styles.width = width
    }

    if (isTablet && widthTablet) {
      styles.width = widthTablet
    }

    if (isDesktop && widthDesktop) {
      styles.width = widthDesktop
    }

    return styles
  }, [isDesktop, isTablet, width, widthDesktop, widthTablet])

  return (
    <BaseButton className={classList} style={style} {...props}>
      {iconLeft && <span className="icon-left">{iconLeft}</span>}
      {children}
      {iconRight && <span className="icon-right">{iconRight}</span>}
    </BaseButton>
  )
}

// Props
Button.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  underline: PropTypes.bool,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  widthTablet: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  widthDesktop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.any,
}

Button.defaultProps = {
  className: null,
  loading: false,
  underline: false,
  iconLeft: null,
  iconRight: null,
  width: null,
  widthTablet: null,
  widthDesktop: null,
  children: null,
}

export default Button
